import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Radio, ArrowUpRight } from "lucide-react";
import { projects } from "../data/portfolioData";

const ITEMS = [
  { name: projects[0].title, url: projects[0].link, description: "Four specialized shops under one roof" },
  ...projects[0].subStores
];

export const FooterTicker = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % ITEMS.length), 4000);
    return () => clearInterval(timer);
  }, []);

  const item = ITEMS[index];

  return (
    <div
      className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--background))] px-4 py-3 mb-12 overflow-hidden"
      data-testid="footer-ticker"
    >
      <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-[hsl(var(--primary))] shrink-0">
        <Radio className="w-3.5 h-3.5 animate-pulse" />
        Now Featuring
      </span>
      <div className="relative h-6 flex-1 w-full sm:w-auto min-w-0">
        <AnimatePresence mode="wait">
          <motion.a
            key={index}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ y: 14, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -14, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="absolute inset-0 flex items-center justify-center sm:justify-start gap-2 text-sm text-[hsl(var(--foreground))] hover:text-[hsl(var(--primary))] transition-colors group"
            data-testid="footer-ticker-link"
          >
            <span className="font-semibold truncate">{item.name}</span>
            <span className="hidden md:inline text-[hsl(var(--muted-foreground))] truncate">
              — {item.description}
            </span>
            <ArrowUpRight className="w-4 h-4 shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </motion.a>
        </AnimatePresence>
      </div>
    </div>
  );
};
